import { CdkMenuTrigger } from '@angular/cdk/menu';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import moment from 'moment';

@Component({
  selector: "app-date-selection",
  templateUrl: "./date-selection.component.html",
  styleUrls: ["./date-selection.component.scss"],
})
export class DateSelectionComponent implements OnInit {
  years: number[] = [];
  startYear: number | null = null;
  endYear: number | null = null;
  minYear: number = 0; // Minimum selectable year
  maxYear: number = 0; // Maximum selectable year
  min: number = 0; // Minimum selectable year
  max: number = 0; // Maximum selectable year
  headerName: string = "Date Selection";
  startrangeYear: any;
  @ViewChild(CdkMenuTrigger) menuTrigger!: CdkMenuTrigger;
  @Output() applyFilter = new EventEmitter<any>();
  @Input("selectedData") selectedData: any;
  @Input("DateConfig") DateConfig: any;
  selectionType:"single"|"multi"="single"

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    
    if(changes['selectedData']?.currentValue!=changes['selectedData']?.previousValue) {
      this.startYear=Number(moment(this.selectedData.from_date || this.selectedData.start).format("YYYY"));
      this.endYear=Number(moment(this.selectedData.to_date || this.selectedData.end).format("YYYY"));
      this.min=Number(moment(this.DateConfig.option.minDate).format("YYYY"));
      this.max=Number(new Date().getFullYear());
      
      let from_date = this.selectedData.from_date || this.selectedData.start;
      let to_date = this.selectedData.from_date || this.selectedData.start;
      this.minYear = new Date(from_date).getFullYear() - 11;
      this.maxYear = new Date(to_date).getFullYear();
      this.generateYears();
      this.startrangeYear = new Date(from_date).getFullYear() - 11;
    }
  }

  generateYears() {
    this.years = Array.from(
      { length: this.maxYear - this.minYear + 1 },
      (_, i) => this.minYear + i
    );
  }

  selectYear(year: number) {
    if (this.isYearDisabled(year)) return;
    if(this.selectionType=="single"){
      this.startYear = year;
      this.endYear = year;
    }else{

    if (this.startYear === null) {
      this.startYear = year;
    } else if (this.endYear === null) {
      this.endYear = year;
      if (this.endYear < this.startYear) {
        [this.startYear, this.endYear] = [this.endYear, this.startYear]; // Swap
      }
    } else {
      this.startYear = year;
      this.endYear = null;
    }
  }
  }

  isYearSelected(year: number): boolean {
    return year === this.startYear || year === this.endYear;
  }

  isYearInRange(year: number): boolean {
    return (
      this.startYear !== null &&
      this.endYear !== null &&
      year >= this.startYear &&
      year <= this.endYear
    );
  }

  isYearDisabled(year: number): boolean {
    return year < this.min || year > this.max;
  }

  getYearStartDate(year: number): Date {
    return new Date(year, 0, 1);
  }

  getYearEndDate(year: number): Date {
    return new Date(year, 11, 31);
  }
  applyDates(): void {
    if (this.startYear !== null && this.endYear !== null) {
      const output = {
        from_date: this.getYearStartDate(this.startYear),
        to_date: this.getYearEndDate(this.endYear),
      };
      this.applyFilter.emit(output);
    } else {
      alert("Please select a start and end quarter.");
    }
     //menu close
     document.getElementById("du-page")?.click()
  }

  clearSelection() {
    this.startYear = null;
    this.endYear = null;
  }

  // Move the start year range backward
  moveStartYearPrevious(): void {
    // if (this.startYear !== null && this.startYear > this.minYear) {
    this.startrangeYear = this.startrangeYear - 4;
    this.minYear = this.minYear - 4;
    this.maxYear = this.maxYear - 4;
    this.generateYears();
    // }
  }

  // Move the start year range forward
  moveStartYearNext(): void {
    // if (this.startYear !== null && this.startYear + 2 < this.maxYear) {
    this.startrangeYear = this.startrangeYear + 4;
    this.minYear = this.minYear + 4;
    this.maxYear = this.maxYear + 4;
    this.generateYears();
    // }
  }
}